var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfettiStrip6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 56",
    width: "100%",
    height: 56,
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 56,
    rx: 6,
    ry: 6
  })), /*#__PURE__*/React.createElement("style", null, "\n      .p { transform-origin: center; animation: fall 3.6s linear infinite; opacity:.9 }\n      .p2 { animation-delay: .4s } .p3 { animation-delay: .8s } .p4 { animation-delay: 1.2s }\n      .p5 { animation-delay: 1.6s } .p6 { animation-delay: 2s } .p7 { animation-delay: 2.4s }\n      @keyframes fall {\n        0% { transform: translateY(-18px) rotate(0deg); opacity:0 }\n        10%{ opacity:1 } 70%{ transform: translateY(40px) rotate(180deg) }\n        100%{ transform: translateY(56px) rotate(270deg); opacity:0 }\n      }\n      @media (prefers-reduced-motion: reduce) { .p { animation: none } }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    x: 10,
    y: 0,
    width: 6,
    height: 8,
    fill: "var(--color-primary,#7C4DFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p2",
    x: 28,
    y: 0,
    width: 6,
    height: 10,
    fill: "var(--color-accent,#37E5FF)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p3",
    x: 46,
    y: 0,
    width: 4,
    height: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p4",
    x: 64,
    y: 0,
    width: 5,
    height: 10,
    fill: "var(--color-accent,#37E5FF)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p5",
    x: 82,
    y: 0,
    width: 6,
    height: 8,
    fill: "var(--color-primary,#7C4DFF)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p6",
    x: 100,
    y: 0,
    width: 4,
    height: 9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p7",
    x: 118,
    y: 0,
    width: 5,
    height: 8,
    fill: "var(--color-accent,#37E5FF)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiStrip6);
export default __webpack_public_path__ + "static/media/confetti-strip-6.65c331c687eaa4451021503f11c59d9f.svg";
export { ForwardRef as ReactComponent };